import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const familyBookSchema = new schema.Entity(
  'family_books',
  {},
  {
    idAttribute: 'id',
  }
)

export const familyBookMemberSchema = new schema.Entity(
  'family_book_members',
  {},
  {
    idAttribute: 'id',
  }
)

export const familyLinkSchema = new schema.Entity(
  'family_links',
  {},
  {
    idAttribute: 'id',
  }
)

export const familyMemberMatchSuggestionSchema = new schema.Entity(
  'family_member_match_suggestions',
  {},
  {
    idAttribute: 'id',
  }
)

export const familyBookAdminSchema = new schema.Entity(
  'family_book_admins',
  {},
  {
    idAttribute: 'id',
  }
)

// ─── FamilyBookController ──────────────────────────────────────────────────

// Route::get('family-books/family-book/{id}/get', 'FamilyBookController@getById');
export const familyBook_getById_Api = {
  backend: `Route::get('family-books/family-book/{id}/get', 'FamilyBookController@getById');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/get',
  method: 'GET',
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// Route::get('family-books/{type}/{id}/gets', 'FamilyBookController@getFamilyBooks');
export const familyBook_getFamilyBooks_Api = {
  backend: `Route::get('family-books/{type}/{id}/gets', 'FamilyBookController@getFamilyBooks');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/gets',
  method: 'GET',
  paramsFields: ['sort_by', 'status', 'keyword'],
  schema: familyBookSchema,
  transform: createListTransform(familyBookSchema),
}
// Route::get('family-books/{owner_type}/{owner_id}/get-by-parish', 'FamilyBookController@getFamilyBooksByParish');
export const familyBook_getFamilyBooksByParish_Api = {
  backend: `Route::get('family-books/{owner_type}/{owner_id}/get-by-parish', 'FamilyBookController@getFamilyBooksByParish');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/get-by-parish',
  method: 'GET',
  paramsFields: ['keyword', 'status', 'zone_group_id', 'exclude_has_children'],
  schema: familyBookSchema,
  transform: createListTransform(familyBookSchema),
}
// Thống kê "Sổ Hộ Gia Đình" (Workspace, đầu tab "Liên kết đến giáo xứ") - response KHÔNG qua
// familyBookSchema/normalizr, cùng lý do familyBook_getFamilyBookForParishReview_Api bên dưới.
// Route::get('family-books/{owner_type}/{owner_id}/get-stats-by-parish', 'FamilyBookController@getFamilyBookStatsByParish');
export const familyBook_getFamilyBookStatsByParish_Api = {
  backend: `Route::get('family-books/{owner_type}/{owner_id}/get-stats-by-parish', 'FamilyBookController@getFamilyBookStatsByParish');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/get-stats-by-parish',
  method: 'GET',
}
// Route::post('family-books/{owner_type}/{owner_id}/family-book/{family_book_id}/change-parish-link-status', 'FamilyBookController@changeFamilyBookParishLinkStatus');
export const familyBook_changeFamilyBookParishLinkStatus_Api = {
  backend: `Route::post('family-books/{owner_type}/{owner_id}/family-book/{family_book_id}/change-parish-link-status', 'FamilyBookController@changeFamilyBookParishLinkStatus');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/family-book/:family_book_id/change-parish-link-status',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// "Xem sổ" DrawDialog riêng của Workspace (tab "Liên kết đến giáo xứ") - response KHÔNG qua
// familyBookSchema/normalizr (như familyBook_getFamilyBookStats_Api bên dưới - 1 view chuyên biệt,
// PHẠM VI HẸP cố tình khác cấu trúc FamilyBookTransformer đầy đủ, không dùng chung entity CRUD với
// phần còn lại của app).
// Route::get('family-books/{owner_type}/{owner_id}/family-book/{family_book_id}/get-for-parish-review', 'FamilyBookController@getFamilyBookForParishReview');
export const familyBook_getFamilyBookForParishReview_Api = {
  backend: `Route::get('family-books/{owner_type}/{owner_id}/family-book/{family_book_id}/get-for-parish-review', 'FamilyBookController@getFamilyBookForParishReview');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/family-book/:family_book_id/get-for-parish-review',
  method: 'GET',
}
// Route::post('family-books/{owner_type}/{owner_id}/family-book/{family_book_id}/update-info-as-parish', 'FamilyBookController@updateFamilyBookInfoAsParish');
export const familyBook_updateFamilyBookInfoAsParish_Api = {
  backend: `Route::post('family-books/{owner_type}/{owner_id}/family-book/{family_book_id}/update-info-as-parish', 'FamilyBookController@updateFamilyBookInfoAsParish');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/family-book/:family_book_id/update-info-as-parish',
  method: 'POST',
  paramsFields: [],
}
// "Ghi chú mục vụ" (family_book_notes) - CHỈ giáo xứ, response KHÔNG qua normalizr (không phải
// entity chuẩn để normalize, cùng lý do familyBook_getFamilyBookStatsByParish_Api).
export const familyBook_getFamilyBookNotes_Api = {
  backend: `Route::get('family-books/{owner_type}/{owner_id}/family-book/{family_book_id}/notes/gets', 'FamilyBookController@getFamilyBookNotes');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/family-book/:family_book_id/notes/gets',
  method: 'GET',
  paramsFields: [],
}
export const familyBook_addFamilyBookNote_Api = {
  backend: `Route::post('family-books/{owner_type}/{owner_id}/family-book/{family_book_id}/notes/add', 'FamilyBookController@addFamilyBookNote');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/family-book/:family_book_id/notes/add',
  method: 'POST',
  paramsFields: [],
}
export const familyBook_deleteFamilyBookNote_Api = {
  backend: `Route::post('family-books/{owner_type}/{owner_id}/family-book/{family_book_id}/notes/{note_id}/delete', 'FamilyBookController@deleteFamilyBookNote');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/family-book/:family_book_id/notes/:note_id/delete',
  method: 'POST',
  paramsFields: [],
}
// Route::post('family-books/{owner_type}/{owner_id}/family-book-member/{family_book_member_id}/update-sacraments-as-parish', 'FamilyBookMemberController@updateFamilyBookMemberSacramentsAsParish');
export const familyBookMember_updateFamilyBookMemberSacramentsAsParish_Api = {
  backend: `Route::post('family-books/{owner_type}/{owner_id}/family-book-member/{family_book_member_id}/update-sacraments-as-parish', 'FamilyBookMemberController@updateFamilyBookMemberSacramentsAsParish');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/family-book-member/:family_book_member_id/update-sacraments-as-parish',
  method: 'POST',
  paramsFields: [],
}
// Route::get('family-books/{type}/{id}/get-stats', 'FamilyBookController@getFamilyBookStats');
export const familyBook_getFamilyBookStats_Api = {
  backend: `Route::get('family-books/{type}/{id}/get-stats', 'FamilyBookController@getFamilyBookStats');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/get-stats',
  method: 'GET',
}
// Route::get('family-books/get-mines', 'FamilyBookController@getMyFamilyBooks');
export const familyBook_getMyFamilyBooks_Api = {
  backend: `Route::get('family-books/get-mines', 'FamilyBookController@getMyFamilyBooks');`,
  root: API_ROOT_URL,
  path: '/family-books/get-mines',
  method: 'GET',
  paramsFields: ['sort_by', 'keyword', 'organization_id'],
  schema: familyBookSchema,
  transform: createListTransform(familyBookSchema),
}
// Route::post('family-books/family-book/create-new', 'FamilyBookController@createMyFamilyBook');
export const familyBook_createMyFamilyBook_Api = {
  backend: `Route::post('family-books/family-book/create-new', 'FamilyBookController@createMyFamilyBook');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/create-new',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// Route::post('family-books/{owner_type}/{owner_id}/family-book/create-new', 'FamilyBookController@createFamilyBook');
export const familyBook_createFamilyBook_Api = {
  backend: `Route::post('family-books/{owner_type}/{owner_id}/family-book/create-new', 'FamilyBookController@createFamilyBook');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/family-book/create-new',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// Route::post('family-books/family-book/{id}/update', 'FamilyBookController@updateFamilyBook');
export const familyBook_updateFamilyBook_Api = {
  backend: `Route::post('family-books/family-book/{id}/update', 'FamilyBookController@updateFamilyBook');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/update',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// Route::post('family-books/family-book/{id}/change-status', 'FamilyBookController@changeFamilyBookStatus');
export const familyBook_changeFamilyBookStatus_Api = {
  backend: `Route::post('family-books/family-book/{id}/change-status', 'FamilyBookController@changeFamilyBookStatus');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/change-status',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// Route::post('family-books/family-book/{id}/delete', 'FamilyBookController@deleteFamilyBook');
export const familyBook_deleteFamilyBook_Api = {
  backend: `Route::post('family-books/family-book/{id}/delete', 'FamilyBookController@deleteFamilyBook');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/delete',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// Route::get('family-books/my-dashboard', 'FamilyBookController@getMyFamilyDashboard');
export const familyBook_getMyFamilyDashboard_Api = {
  backend: `Route::get('family-books/my-dashboard', 'FamilyBookController@getMyFamilyDashboard');`,
  root: API_ROOT_URL,
  path: '/family-books/my-dashboard',
  method: 'GET',
}
// Route::get('family-books/my-forests', 'FamilyBookController@getMyFamilyForests');
export const familyBook_getMyFamilyForests_Api = {
  backend: `Route::get('family-books/my-forests', 'FamilyBookController@getMyFamilyForests');`,
  root: API_ROOT_URL,
  path: '/family-books/my-forests',
  method: 'GET',
}
// Route::post('family-books/family-book/{id}/add-parent', 'FamilyBookController@addParentBook');
export const familyBook_addParentBook_Api = {
  backend: `Route::post('family-books/family-book/{id}/add-parent', 'FamilyBookController@addParentBook');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/add-parent',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// Route::post('family-books/family-book/{family_book_id}/release-ownership', 'FamilyBookController@releaseFamilyBookOwnership');
export const familyBook_releaseFamilyBookOwnership_Api = {
  backend: `Route::post('family-books/family-book/{family_book_id}/release-ownership', 'FamilyBookController@releaseFamilyBookOwnership');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:family_book_id/release-ownership',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// Route::get('family-books/family-book/{family_book_id}/admins/gets', 'FamilyBookController@getFamilyBookAdmins');
export const familyBook_getFamilyBookAdmins_Api = {
  backend: `Route::get('family-books/family-book/{family_book_id}/admins/gets', 'FamilyBookController@getFamilyBookAdmins');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/admins/gets',
  method: 'GET',
  paramsFields: [],
  schema: familyBookAdminSchema,
  transform: createListTransform(familyBookAdminSchema),
}
// Route::post('family-books/family-book/{family_book_id}/admins/add', 'FamilyBookController@addFamilyBookAdmin');
export const familyBook_addFamilyBookAdmin_Api = {
  backend: `Route::post('family-books/family-book/{family_book_id}/admins/add', 'FamilyBookController@addFamilyBookAdmin');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/admins/add',
  method: 'POST',
  paramsFields: [],
  schema: familyBookAdminSchema,
  transform: createTransform(familyBookAdminSchema, 'data'),
}
// Route::post('family-books/family-book-admins/{id}/remove', 'FamilyBookController@removeFamilyBookAdmin');
export const familyBook_removeFamilyBookAdmin_Api = {
  backend: `Route::post('family-books/family-book-admins/{id}/remove', 'FamilyBookController@removeFamilyBookAdmin');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book-admins/:id/remove',
  method: 'POST',
  paramsFields: [],
}
// Route::get('family-books/family-book/{id}/get-logs', 'FamilyBookController@fetchChangeLogs');
export const familyBook_fetchChangeLogs_Api = {
  backend: `Route::get('family-books/family-book/{id}/get-logs', 'FamilyBookController@fetchChangeLogs');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/get-logs',
  method: 'GET',
}
// Import GEDCOM (.ged) cá nhân - sổ tạo ra thuộc về chính user gọi API, không cần :type/:id. Import
// Excel theo owner tổ chức (tạo Sổ hàng loạt) đã thay bằng bộ Xuất/Nhập hàng loạt generic
// (familyBookImportExport_*_Api bên dưới, key='family_book') - không khai schema/transform -
// response là thống kê import (families_created, members_created...), không phải 1 family_book
// entity để normalize, xem GedcomImportCard (containers/FamilyBooks.js) đọc thẳng qua callApi().
export const familyBook_importGedcom_Api = {
  name: 'familyBook_importGedcom_Api',
  backend: `Route::post('family-books/family-book/import-gedcom', 'FamilyBookController@importGedcomFile');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/import-gedcom',
  method: 'POST',
}

// ─── FamilyBookMemberController ────────────────────────────────────────────

// Route::get('family-books/family-book-member/{id}/get', 'FamilyBookMemberController@getById');
export const familyBookMember_getById_Api = {
  backend: `Route::get('family-books/family-book-member/{id}/get', 'FamilyBookMemberController@getById');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book-member/:id/get',
  method: 'GET',
  schema: familyBookMemberSchema,
  transform: createTransform(familyBookMemberSchema, 'data'),
}
// Route::get('family-books/members/mine', 'FamilyBookMemberController@getMyFamilyBookMembers');
export const familyBookMember_getMine_Api = {
  backend: `Route::get('family-books/members/mine', 'FamilyBookMemberController@getMyFamilyBookMembers');`,
  root: API_ROOT_URL,
  path: '/family-books/members/mine',
  method: 'GET',
  schema: familyBookMemberSchema,
  transform: createListTransform(familyBookMemberSchema),
}
// Route::get('family-books/family-book/{family_book_id}/members/gets', 'FamilyBookMemberController@getFamilyBookMembers');
export const familyBookMember_getFamilyBookMembers_Api = {
  backend: `Route::get('family-books/family-book/{family_book_id}/members/gets', 'FamilyBookMemberController@getFamilyBookMembers');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/members/gets',
  method: 'GET',
  paramsFields: ['sort_by', 'keyword'],
  schema: familyBookMemberSchema,
  transform: createListTransform(familyBookMemberSchema),
}
// Route::get('family-books/{owner_type}/{owner_id}/members/query', 'FamilyBookMemberController@fetchFamilyBookMembers');
export const familyBookMember_fetchFamilyBookMembers_Api = {
  backend: `Route::get('family-books/{owner_type}/{owner_id}/members/query', 'FamilyBookMemberController@fetchFamilyBookMembers');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/members/query',
  method: 'GET',
  paramsFields: ['sort_by', 'sacrament_type', 'keyword', 'gender', 'zone_group_id', 'age_min', 'age_max'],
  schema: familyBookMemberSchema,
  transform: createListTransform(familyBookMemberSchema),
}
// Route::get('family-books/{owner_type}/{owner_id}/members/query-by-parish', 'FamilyBookMemberController@fetchFamilyBookMembersByParish');
export const familyBookMember_fetchFamilyBookMembersByParish_Api = {
  backend: `Route::get('family-books/{owner_type}/{owner_id}/members/query-by-parish', 'FamilyBookMemberController@fetchFamilyBookMembersByParish');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/members/query-by-parish',
  method: 'GET',
  paramsFields: ['sort_by', 'sacrament_type', 'exclude_sacrament_type', 'keyword', 'gender', 'zone_group_id', 'age_min', 'age_max'],
  schema: familyBookMemberSchema,
  transform: createListTransform(familyBookMemberSchema),
}
// Tab thứ 3 "Bí tích cử hành tại giáo xứ" - căn theo family_book_member_sacraments.parish_id (giáo
// xứ ĐÃ CỬ HÀNH bí tích), KHÁC hẳn 2 API trên (căn theo family_books.parish_id/owner_id) - xem
// comment đầy đủ ở FamilyBookMemberController::fetchFamilyBookMembersByCelebrationParish().
export const familyBookMember_fetchFamilyBookMembersByCelebrationParish_Api = {
  backend: `Route::get('family-books/{owner_type}/{owner_id}/members/query-by-celebration-parish', 'FamilyBookMemberController@fetchFamilyBookMembersByCelebrationParish');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/members/query-by-celebration-parish',
  method: 'GET',
  paramsFields: ['sort_by', 'sacrament_type', 'keyword', 'gender', 'zone_group_id', 'age_min', 'age_max'],
  schema: familyBookMemberSchema,
  transform: createListTransform(familyBookMemberSchema),
}
// Thống kê "Giáo Dân" (Workspace, đầu tab "Tra cứu Giáo dân") - response KHÔNG qua
// familyBookMemberSchema/normalizr, cùng lý do familyBook_getFamilyBookStatsByParish_Api.
// Route::get('family-books/{owner_type}/{owner_id}/members/get-stats-by-parish', 'FamilyBookMemberController@getMemberStatsByParish');
export const familyBookMember_getMemberStatsByParish_Api = {
  backend: `Route::get('family-books/{owner_type}/{owner_id}/members/get-stats-by-parish', 'FamilyBookMemberController@getMemberStatsByParish');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/members/get-stats-by-parish',
  method: 'GET',
}
// "Kỷ Niệm Sắp Tới" toàn giáo xứ (Tổng quan Workspace) - response KHÔNG qua normalizr, cùng lý do
// familyBookMember_getMemberStatsByParish_Api ở trên.
export const familyBookMember_getUpcomingMomentsByParish_Api = {
  backend: `Route::get('family-books/{owner_type}/{owner_id}/members/get-upcoming-moments-by-parish', 'FamilyBookMemberController@getUpcomingMomentsByParish');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/members/get-upcoming-moments-by-parish',
  method: 'GET',
}
// "Xuất/Nhập hàng loạt" GENERIC (Sổ/Thành viên/Bí tích - :key khớp
// config/family_book_import_export.php phía BE, xem import_export_config.js phía FE) - 4 API DÙNG
// CHUNG cho cả 3 loại, KHÔNG qua normalizr (response không phải entity chuẩn để normalize).
export const familyBookImportExport_getDefinition_Api = {
  backend: `Route::get('family-books/{owner_type}/{owner_id}/import-export/{key}/get-definition', 'FamilyBookImportExportController@getDefinition');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/import-export/:key/get-definition',
  method: 'GET',
}
export const familyBookImportExport_exportTemplate_Api = {
  backend: `Route::post('family-books/{owner_type}/{owner_id}/import-export/{key}/export-template', 'FamilyBookImportExportController@exportTemplate');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/import-export/:key/export-template',
  method: 'POST',
}
// values: {file} - upload file, gọi qua callApi() trực tiếp (ngoại lệ đã chốt cho upload file,
// KHÔNG qua useAsyncAction - xem GedcomImportCard trong containers/FamilyBooks.js).
export const familyBookImportExport_previewImport_Api = {
  backend: `Route::post('family-books/{owner_type}/{owner_id}/import-export/{key}/preview-import', 'FamilyBookImportExportController@previewImport');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/import-export/:key/preview-import',
  method: 'POST',
}
export const familyBookImportExport_applyImport_Api = {
  backend: `Route::post('family-books/{owner_type}/{owner_id}/import-export/{key}/apply-import', 'FamilyBookImportExportController@applyImport');`,
  root: API_ROOT_URL,
  path: '/family-books/:type/:id/import-export/:key/apply-import',
  method: 'POST',
}
// "+" nhanh ở popup Hồ Sơ Thành Viên (Chồng/Vợ/Con) - id ở đây là ANCHOR member (người đang xem),
// KHÁC familyBook_createFamilyBookMember_Api bên dưới (id là family_book_id có sẵn) - BE tự
// tạo/dùng lại sổ riêng của anchor, xem FamilyBookMember::ensureOwnFamilyBook().
// Route::post('family-books/family-book-member/{family_book_member_id}/add-own-relative', 'FamilyBookMemberController@addOwnRelative');
export const familyBook_addOwnRelative_Api = {
  backend: `Route::post('family-books/family-book-member/{family_book_member_id}/add-own-relative', 'FamilyBookMemberController@addOwnRelative');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book-member/:id/add-own-relative',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// Route::post('family-books/family-book/{family_book_id}/members/create-new', 'FamilyBookMemberController@createFamilyBookMember');
export const familyBook_createFamilyBookMember_Api = {
  backend: `Route::post('family-books/family-book/{family_book_id}/members/create-new', 'FamilyBookMemberController@createFamilyBookMember');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/members/create-new',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// Route::post('family-books/family-book-members/{id}/update', 'FamilyBookMemberController@updateFamilyBookMember');
export const familyBook_updateFamilyBookMember_Api = {
  backend: `Route::post('family-books/family-book-members/{id}/update', 'FamilyBookMemberController@updateFamilyBookMember');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book-members/:id/update',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// Route::post('family-books/family-book-members/{id}/delete', 'FamilyBookMemberController@deleteFamilyBookMember');
export const familyBook_deleteFamilyBookMember_Api = {
  backend: `Route::post('family-books/family-book-members/{id}/delete', 'FamilyBookMemberController@deleteFamilyBookMember');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book-members/:id/delete',
  method: 'POST',
  paramsFields: [],
  schema: familyBookSchema,
  transform: createTransform(familyBookSchema, 'data'),
}
// "Gửi lại thư mời" - trả về CHÍNH member (familyBookMemberSchema, khác 3 API member ở trên đều trả
// familyBookSchema) - FE dùng invite_sent_count/invite_last_sent_at/can_resend_invite cập nhật ngay
// trên form, không cần refetch riêng. Tối đa 3 lần/cách nhau 1 ngày, xem
// FamilyBookMember::canResendInvite() (BE).
// Route::post('family-books/family-book-members/{id}/resend-invite', 'FamilyBookMemberController@resendInvite');
export const familyBookMember_resendInvite_Api = {
  backend: `Route::post('family-books/family-book-members/{id}/resend-invite', 'FamilyBookMemberController@resendInvite');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book-members/:id/resend-invite',
  method: 'POST',
  paramsFields: [],
  schema: familyBookMemberSchema,
  transform: createTransform(familyBookMemberSchema, 'data'),
}
// Ơn Gọi Thánh Hiến - thêm/sửa/xoá từng dòng theo id (khác familyBook_updateFamilyBookMember_Api ở
// trên - đó là flat-field upsert-theo-type cho bí tích). Không có schema/transform - MemberDetailModal
// không normalize qua Redux, chỉ đọc lại qua familyBookMember_getById_Api (refreshToken) sau khi
// thêm/sửa/xoá, cùng cách sacraments đang làm.
// Route::post('family-books/family-book-member/{family_book_member_id}/vocations/add', 'FamilyBookMemberController@addFamilyBookMemberVocation');
export const familyBook_addFamilyBookMemberVocation_Api = {
  backend: `Route::post('family-books/family-book-member/{family_book_member_id}/vocations/add', 'FamilyBookMemberController@addFamilyBookMemberVocation');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book-member/:id/vocations/add',
  method: 'POST',
  paramsFields: [],
}
// Route::post('family-books/family-book-member-vocations/{id}/update', 'FamilyBookMemberController@updateFamilyBookMemberVocation');
export const familyBook_updateFamilyBookMemberVocation_Api = {
  backend: `Route::post('family-books/family-book-member-vocations/{id}/update', 'FamilyBookMemberController@updateFamilyBookMemberVocation');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book-member-vocations/:id/update',
  method: 'POST',
  paramsFields: [],
}
// Route::post('family-books/family-book-member-vocations/{id}/delete', 'FamilyBookMemberController@deleteFamilyBookMemberVocation');
export const familyBook_deleteFamilyBookMemberVocation_Api = {
  backend: `Route::post('family-books/family-book-member-vocations/{id}/delete', 'FamilyBookMemberController@deleteFamilyBookMemberVocation');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book-member-vocations/:id/delete',
  method: 'POST',
  paramsFields: [],
}

// Lịch Sử Chuyển Sổ - thêm/sửa/xoá từng dòng theo id, KHÔNG ảnh hưởng parish_id hiện tại của sổ
// (đổi giáo xứ HIỆN TẠI vẫn qua familyBook_updateFamilyBook_Api như cũ, tự động ghi 1 dòng lịch
// sử mới ở BE). Tên GENERIC "transfer" (không khoá cứng vào riêng "parish") - xem
// 072_create_family_book_transfer_logs.sql (kristo repo). Không có schema/transform -
// FamilyBookTransferLogSection không normalize qua Redux, chỉ đọc lại qua
// familyBook_getFamilyBookTransferLogs_Api (refreshToken) sau khi thêm/sửa/xoá, cùng cách
// vocations đang làm.
// Route::get('family-books/family-book/{family_book_id}/transfer-logs/gets', 'FamilyBookController@getFamilyBookTransferLogs');
export const familyBook_getFamilyBookTransferLogs_Api = {
  backend: `Route::get('family-books/family-book/{family_book_id}/transfer-logs/gets', 'FamilyBookController@getFamilyBookTransferLogs');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/transfer-logs/gets',
  method: 'GET',
  paramsFields: [],
}
// Route::post('family-books/family-book/{family_book_id}/transfer-logs/add', 'FamilyBookController@addFamilyBookTransferLog');
export const familyBook_addFamilyBookTransferLog_Api = {
  backend: `Route::post('family-books/family-book/{family_book_id}/transfer-logs/add', 'FamilyBookController@addFamilyBookTransferLog');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book/:id/transfer-logs/add',
  method: 'POST',
  paramsFields: [],
}
// Route::post('family-books/family-book-transfer-logs/{id}/update', 'FamilyBookController@updateFamilyBookTransferLog');
export const familyBook_updateFamilyBookTransferLog_Api = {
  backend: `Route::post('family-books/family-book-transfer-logs/{id}/update', 'FamilyBookController@updateFamilyBookTransferLog');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book-transfer-logs/:id/update',
  method: 'POST',
  paramsFields: [],
}
// Route::post('family-books/family-book-transfer-logs/{id}/delete', 'FamilyBookController@deleteFamilyBookTransferLog');
export const familyBook_deleteFamilyBookTransferLog_Api = {
  backend: `Route::post('family-books/family-book-transfer-logs/{id}/delete', 'FamilyBookController@deleteFamilyBookTransferLog');`,
  root: API_ROOT_URL,
  path: '/family-books/family-book-transfer-logs/:id/delete',
  method: 'POST',
  paramsFields: [],
}

// ─── FamilyLinkController (QR link) ────────────────────────────────────────

// Route::post('family-links/request', 'FamilyLinkController@requestLink');
export const familyLink_requestLink_Api = {
  backend: `Route::post('family-links/request', 'FamilyLinkController@requestLink');`,
  root: API_ROOT_URL,
  path: '/family-links/request',
  method: 'POST',
  paramsFields: [],
  schema: familyLinkSchema,
  transform: createTransform(familyLinkSchema, 'data'),
}
// Route::get('family-links/link/{id}/get', 'FamilyLinkController@getById');
export const familyLink_getById_Api = {
  backend: `Route::get('family-links/link/{id}/get', 'FamilyLinkController@getById');`,
  root: API_ROOT_URL,
  path: '/family-links/link/:id/get',
  method: 'GET',
  schema: familyLinkSchema,
  transform: createTransform(familyLinkSchema, 'data'),
}
// Route::get('family-links/for-book/{family_book_id}', 'FamilyLinkController@getFamilyLinksForBook');
export const familyLink_getFamilyLinksForBook_Api = {
  backend: `Route::get('family-links/for-book/{family_book_id}', 'FamilyLinkController@getFamilyLinksForBook');`,
  root: API_ROOT_URL,
  path: '/family-links/for-book/:id',
  method: 'GET',
  paramsFields: ['status'],
  schema: familyLinkSchema,
  transform: createListTransform(familyLinkSchema),
}
// Route::post('family-links/link/{id}/accept', 'FamilyLinkController@accept');
export const familyLink_accept_Api = {
  backend: `Route::post('family-links/link/{id}/accept', 'FamilyLinkController@accept');`,
  root: API_ROOT_URL,
  path: '/family-links/link/:id/accept',
  method: 'POST',
  schema: familyLinkSchema,
  transform: createTransform(familyLinkSchema, 'data'),
}
// Route::post('family-links/link/{id}/reject', 'FamilyLinkController@reject');
export const familyLink_reject_Api = {
  backend: `Route::post('family-links/link/{id}/reject', 'FamilyLinkController@reject');`,
  root: API_ROOT_URL,
  path: '/family-links/link/:id/reject',
  method: 'POST',
}
// Route::post('family-links/link/{id}/revoke', 'FamilyLinkController@revoke');
export const familyLink_revoke_Api = {
  backend: `Route::post('family-links/link/{id}/revoke', 'FamilyLinkController@revoke');`,
  root: API_ROOT_URL,
  path: '/family-links/link/:id/revoke',
  method: 'POST',
  schema: familyLinkSchema,
  transform: createTransform(familyLinkSchema, 'data'),
}
// Quét lại gợi ý trùng thủ công cho 1 sổ ĐÃ liên kết (vd vừa thêm thành viên mới) - không có
// schema/transform (không phải family_link entity, chỉ trả pending_count để báo ngay số gợi ý mới).
// Route::post('family-links/link/{id}/rescan', 'FamilyLinkController@rescan');
export const familyLink_rescan_Api = {
  backend: `Route::post('family-links/link/{id}/rescan', 'FamilyLinkController@rescan');`,
  root: API_ROOT_URL,
  path: '/family-links/link/:id/rescan',
  method: 'POST',
  paramsFields: [],
}

// ─── FamilyMemberMatchSuggestionController ─────────────────────────────────

// Route::get('family-member-match-suggestions/for-book/{family_book_id}', '...@getFamilyMemberMatchSuggestionsForBook');
export const familyMemberMatchSuggestion_getForBook_Api = {
  backend: `Route::get('family-member-match-suggestions/for-book/{family_book_id}', 'FamilyMemberMatchSuggestionController@getFamilyMemberMatchSuggestionsForBook');`,
  root: API_ROOT_URL,
  path: '/family-member-match-suggestions/for-book/:id',
  method: 'GET',
  paramsFields: ['status'],
  schema: familyMemberMatchSuggestionSchema,
  transform: createListTransform(familyMemberMatchSuggestionSchema),
}
// Ghép tay 2 member cụ thể (chưa chắc có sẵn suggestion nào cho đúng cặp - BE tự tìm-hoặc-tạo rồi
// confirm luôn, xem FamilyMemberMatchSuggestionController::manualMatch()). Dùng ở màn chọn thành
// viên 2 sổ để nối (mở từ tab "Sổ Đã Liên Kết" khi chưa có matched_members nào cho 1 link).
// Route::post('family-member-match-suggestions/manual-match', '...@manualMatch');
export const familyMemberMatchSuggestion_manualMatch_Api = {
  backend: `Route::post('family-member-match-suggestions/manual-match', 'FamilyMemberMatchSuggestionController@manualMatch');`,
  root: API_ROOT_URL,
  path: '/family-member-match-suggestions/manual-match',
  method: 'POST',
  paramsFields: [],
  schema: familyMemberMatchSuggestionSchema,
  transform: createTransform(familyMemberMatchSuggestionSchema, 'data'),
}
// Route::post('family-member-match-suggestions/{id}/confirm', '...@confirm');
export const familyMemberMatchSuggestion_confirm_Api = {
  backend: `Route::post('family-member-match-suggestions/{id}/confirm', 'FamilyMemberMatchSuggestionController@confirm');`,
  root: API_ROOT_URL,
  path: '/family-member-match-suggestions/:id/confirm',
  method: 'POST',
  schema: familyMemberMatchSuggestionSchema,
  transform: createTransform(familyMemberMatchSuggestionSchema, 'data'),
}
// Route::post('family-member-match-suggestions/{id}/reject', '...@reject');
export const familyMemberMatchSuggestion_reject_Api = {
  backend: `Route::post('family-member-match-suggestions/{id}/reject', 'FamilyMemberMatchSuggestionController@reject');`,
  root: API_ROOT_URL,
  path: '/family-member-match-suggestions/:id/reject',
  method: 'POST',
  schema: familyMemberMatchSuggestionSchema,
  transform: createTransform(familyMemberMatchSuggestionSchema, 'data'),
}
// Route::post('family-member-match-suggestions/{id}/undo-confirm', '...@undoConfirm');
export const familyMemberMatchSuggestion_undoConfirm_Api = {
  backend: `Route::post('family-member-match-suggestions/{id}/undo-confirm', 'FamilyMemberMatchSuggestionController@undoConfirm');`,
  root: API_ROOT_URL,
  path: '/family-member-match-suggestions/:id/undo-confirm',
  method: 'POST',
  schema: familyMemberMatchSuggestionSchema,
  transform: createTransform(familyMemberMatchSuggestionSchema, 'data'),
}
